import { useMemo } from "react";
import { useAllRoyaltiesByYear } from "@seabrookstudios/pitch2table";

/**
 * Query wrapper to fetch royalties grouped by year and also provide summed units per year.
 *
 * @returns {{
 *  data: import("@seabrookstudios/pitch2table-core").RoyaltyEventForApp[][],
 *  unitsByYear: number[],
 *  isLoading: boolean,
 *  isFetching: boolean,
 *  refetch: () => Promise<unknown>,
 * }}
 */
export const useAllRoyaltiesUnitsByYear = () => {
  const { data: byYear = [], isLoading, isFetching, refetch } = useAllRoyaltiesByYear();

  const unitsByYear = useMemo(() => {
    return byYear.map((royalties) => royalties.reduce((sum, r) => sum + (r.units || 0), 0));
  }, [byYear]);

  return { data: byYear, unitsByYear, isLoading, isFetching, refetch };
};

